import Image from '../../../basic/image';
import QuickLink from '../../../basic/quickLink';
import { IHeaderProps } from '../IHeader';
import NavMenuBlocks from './nav-menu/nav-menu-blocks';
import NavMenuToolbar from './nav-menu-toolbar';
import HeaderToolbar from './header-toolbar';
import { SearchButton } from './headerComponents/header-steps';
import { useUserProfile } from '../../../../providers/user-provider';
import {
  DataAnalyticsLocations,
  DataAnalyticsTypes,
  buildAnalytics,
} from '../../../basic/analytics';
import { useCookieBanner } from '../hooks/useCookiesBanner';
import { getSession } from '../../../../utils/sessionStorageUtils';

export default function DesktopNavbar({
  headerProps,
}: Readonly<{ headerProps: IHeaderProps }>): JSX.Element {
  const { siteSearch, navToolbarMap, newMenuBlocks, siteLogo, regionMessages } = headerProps;
  const { userProfile } = useUserProfile();
  useCookieBanner();
  const isLoggedIn = getSession('isLoggedIn');
  const { loginError } = useUserProfile();
  // Show the logged-in header when profile data exists or the session indicates a logged-in user
  // outside the login route and there is no login error.
  const showLoggedInHeaderView =
    userProfile ??
    (!loginError &&
      isLoggedIn &&
      isLoggedIn === 'true' &&
      location.pathname.split('/')[2] !== 'login');

  return (
    <>
      <div className="flex bg-secondary-400">
        <div className="md:container md:mx-auto shadow-md py-3">
          <HeaderToolbar
            regionMessages={regionMessages}
            navToolbarMap={navToolbarMap}
            notificationErrorMsg={headerProps?.notificationErrorsMsg}
          ></HeaderToolbar>
        </div>
      </div>

      <div className="flex bg-inky">
        <div className="md:container md:mx-auto py-3">
          <div className="grid grid-cols-4 gap-4">
            <div>
              {siteLogo.url && (
                <QuickLink
                  href="/"
                  aria-label={siteLogo.alt}
                  data-testid="header-logo-link"
                  dataAnalytics={buildAnalytics(
                    DataAnalyticsLocations.Header,
                    DataAnalyticsTypes.Media,
                  )}
                >
                  <Image alt={siteLogo.alt || ''} src={siteLogo.url} layout="responsive" />
                </QuickLink>
              )}
            </div>
            <div className="col-span-1"></div>
            {showLoggedInHeaderView && (
              <div className="col-span-2 flex justify-end items-center">
                <SearchButton searchBar={siteSearch} />
              </div>
            )}
            {!showLoggedInHeaderView && (
              <div className="col-span-2 flex justify-end">
                <NavMenuToolbar toolMap={navToolbarMap} iconOnly />
              </div>
            )}
          </div>
          <div className="grid xl:grid-flow-col xl:auto-cols-auto gap-2 basis-full pt-base">
            <NavMenuBlocks menuBlocks={newMenuBlocks} />
            {!showLoggedInHeaderView && (
              <div className="flex justify-end items-center">
                <SearchButton searchBar={siteSearch} />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
